var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmartGarden(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "MeinGarten",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 65,
    height: 74,
    viewBox: "0 0 65 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      #MeinGarten .cls-1 {\n        fill: none;\n        stroke: #707070;\n      }\n\n      #MeinGarten .cls-2 {\n        fill: #c5d75d;\n      }\n\n      #MeinGarten .cls-3 {\n        MeinGarten_clip-path: url(#MeinGarten_clip-path);\n      }\n\n      #MeinGarten .cls-4 {\n        fill: url(#MeinGarten_linear-gradient);\n      }\n\n      #MeinGarten .cls-5 {\n        fill: #fff;\n      }\n\n      #MeinGarten .cls-6 {\n        fill: #f5f5f5;\n      }\n\n      #MeinGarten .cls-7 {\n        filter: url(#MeinGarten_Pfad_2659);\n      }\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "MeinGarten_Pfad_2659",
    x: 0,
    y: 0,
    width: 65,
    height: 74,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "MeinGarten_clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2662",
    "data-name": "Pfad 2662",
    className: "cls-1",
    d: "M7,33.619h3.953V25.906l5.123-2.953,5.1,2.953H32.967V45.048l-3.7,2.39-2.547,2.841H8.174Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "MeinGarten_linear-gradient",
    x1: 0.68,
    y1: 0.409,
    x2: 0.29,
    y2: 0.936,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c5d75d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261,
    stopColor: "#c5d75d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33bc12"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(9 6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2710",
    "data-name": "Gruppe 2710"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7",
    transform: "matrix(1, 0, 0, 1, -9, -6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "MeinGarten_Pfad_2659-2",
    "data-name": "Pfad 2659",
    className: "cls-2",
    d: "M0,0H47V33A23,23,0,0,1,24,56H23A23,23,0,0,1,0,33Z",
    transform: "translate(9 6)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_maskieren_8",
    "data-name": "Gruppe maskieren 8",
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_540",
    "data-name": "Ellipse 540",
    className: "cls-4",
    cx: 17,
    cy: 17,
    r: 17,
    transform: "translate(7 15)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2660",
    "data-name": "Pfad 2660",
    className: "cls-5",
    d: "M23.5,53.664A21.251,21.251,0,0,1,20.34,11.4l.222,1.483A19.751,19.751,0,1,0,43.25,32.414a19.932,19.932,0,0,0-.55-4.65l1.459-.351A21.272,21.272,0,0,1,23.5,53.664"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2661",
    "data-name": "Pfad 2661",
    className: "cls-6",
    d: "M41.848,23.4a12.476,12.476,0,0,0-6.312,3.146,10.828,10.828,0,0,0-2.075,3.006V22.915a2.911,2.911,0,0,1,1.29.687c1.169,1.094,2.107.679,2.086-.921a2.988,2.988,0,0,1,2.869-3.007c1.6-.054,1.971-1.011.824-2.127a2.99,2.99,0,0,1-.1-4.156c1.094-1.169.679-2.107-.921-2.086A2.988,2.988,0,0,1,36.5,8.436c-.054-1.6-1.011-1.971-2.127-.824a2.989,2.989,0,0,1-4.156.1c-1.169-1.093-2.107-.679-2.086.922a2.989,2.989,0,0,1-2.87,3.007c-1.6.054-1.97,1.011-.823,2.127a2.99,2.99,0,0,1,.1,4.156c-1.093,1.169-.679,2.107.922,2.086a2.988,2.988,0,0,1,3.007,2.869c.054,1.6,1.01,1.971,2.127.824a2.933,2.933,0,0,1,1.454-.81V36.338a13.168,13.168,0,0,0-2.8-4.349A14.041,14.041,0,0,0,22.719,28.5a14.041,14.041,0,0,0,3.488,6.531,13.884,13.884,0,0,0,5.842,3.315v6.938a15.871,15.871,0,0,1-24.188-10.8c2.061,0,2.71-.009,2.943-.012a.772.772,0,0,0,.135-.006.706.706,0,0,0,.608-.7V26.271a.711.711,0,0,0-.066-.3l4.568-2.686,4.316,2.654a.708.708,0,0,0-.082.331v7.458h1.412V26.977h.557a.706.706,0,0,0,.369-1.307l-6.194-3.809a.7.7,0,0,0-.727-.008L9.221,25.662a.706.706,0,0,0,.358,1.315h.555v6.086c-.529,0-1.458.006-3.082.006a.706.706,0,0,0-.7.785,17.282,17.282,0,0,0,26.8,12.4.705.705,0,0,0,.311-.586V32.621a12.024,12.024,0,0,0,5.241-2.9A12.467,12.467,0,0,0,41.848,23.4M30.087,16.716a2.623,2.623,0,1,1,3.459,1.339,2.623,2.623,0,0,1-3.459-1.339"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_2446",
    "data-name": "Rechteck 2446",
    className: "cls-5",
    width: 2.755,
    height: 5.931,
    transform: "translate(14.579 27.688)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartGarden);
export default __webpack_public_path__ + "static/media/smart-garden.e08967beb50b8ee1b5131745ce36988d.svg";
export { ForwardRef as ReactComponent };